import { useCallback } from 'react'
import { getAttachment } from '@/api/maintenance-tickets-api'

export const useOpenAttachment = () => {
  const openAttachment = useCallback(async (attachmentName: string) => {
    try {
      const response = await getAttachment(attachmentName)
      window.open(response.data, '_blank')
    } catch (error) {
      console.error('Failed to open attachment:', error)
    }
  }, [])

  return openAttachment
}
